export const catalog_matrix = [
  {form_key:'classification_id', catalog_key:'client_classifications'},
  {form_key:'pre_fiscal_regime_id', catalog_key:'business_fiscal_regimes'},
  {form_key:'pre_contact_medium_id', catalog_key:'client_contact_mediums'},
  //{form_key:'pre_responsible_id', catalog_key:'none', propname:'users'},
]